import log from "./main/Log.js";
import error from "./main/Error.js";
import event_track from "./main/Event_track.js";
import debug from "./main/Debug.js";
import { logShooter, initSentry } from "./utils/logShooter.js";
import { setup } from "./utils/setup.js";

let isInitialized = false;

function initialize(userArgs) {
    setup(userArgs);
    isInitialized = true;
    const sentry = initSentry()
    logShooter(sentry)
}

export default {
    log,
    error,
    event_track,
    debug,
    initialize,
}